"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _theme = require("../utils/theme");
var _RadioButton = require("./RadioButton.styles");
var _helpers = require("@qwkin/helpers");
var _Text = require("../Text");
var _excluded = ["theme", "onChange", "group", "value", "children"];
var RadioButton = function RadioButton(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? _helpers.identity : _ref$onChange,
    group = _ref.group,
    value = _ref.value,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_RadioButton.RadioButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_RadioButton.PlainRadioButton, (0, _extends2["default"])({
    type: "radio",
    name: group,
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.currentTarget.value);
    }
  }, props)), /*#__PURE__*/_react["default"].createElement(_RadioButton.RadioButtonLabel, null), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    className: "radioButtonLabel"
  }, children)));
};
var _default = exports["default"] = RadioButton;